import { createContext, useContext } from 'react';
import { Application, APPLICATION } from './application';
import { Shop, SHOP } from './shop';
import { Goods, GOODS } from './goods';
import { Order, ORDER } from './order';
import { Notice, NOTICE } from './notice';

function createStores() {
  return {
    [APPLICATION]: new Application(),
    [SHOP]: new Shop(),
    [GOODS]: new Goods(),
    [ORDER]: new Order(),
    [NOTICE]: new Notice(),
  };
}

const stores = createStores();

const StoresContext = createContext(stores);

const useStores = () => useContext(StoresContext);

export { stores, useStores, StoresContext };
